import React, { useState } from 'react';
import { Card, Table, Button, Tag, Space, Input, Select, DatePicker } from 'antd';
import { EyeOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import './AdminCommon.css';

const { Option } = Select;
const { RangePicker } = DatePicker;

const OrderManagement = () => {
  const [orders, setOrders] = useState([
    { id: 'ORD001', user: '张三', expert: '李四', service: '音乐推广咨询', amount: 299, status: 'completed', createdAt: '2026-05-29' },
    { id: 'ORD002', user: '王五', expert: '赵六', service: '发行策略咨询', amount: 199, status: 'pending', createdAt: '2026-05-28' },
    { id: 'ORD003', user: '钱七', expert: '孙八', service: '内容创作指导', amount: 399, status: 'cancelled', createdAt: '2026-05-27' },
  ]);

  const columns = [
    { title: '订单号', dataIndex: 'id', key: 'id' },
    { title: '用户', dataIndex: 'user', key: 'user' },
    { title: '专家', dataIndex: 'expert', key: 'expert' },
    { title: '服务', dataIndex: 'service', key: 'service' },
    { title: '金额', dataIndex: 'amount', key: 'amount', render: (v) => `¥${v}` },
    { 
      title: '状态', 
      dataIndex: 'status', 
      key: 'status',
      render: (status) => {
        const colors = { pending: 'orange', completed: 'green', cancelled: 'red', processing: 'blue' };
        const labels = { pending: '待处理', completed: '已完成', cancelled: '已取消', processing: '进行中' };
        return <Tag color={colors[status]}>{labels[status]}</Tag>;
      }
    },
    { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button icon={<EyeOutlined />} size="small">详情</Button>
          {record.status === 'pending' && (
            <>
              <Button icon={<CheckCircleOutlined />} size="small" type="primary">确认</Button>
              <Button icon={<CloseCircleOutlined />} size="small" danger>取消</Button>
            </>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div className="admin-page">
      <div className="page-header">
        <h1 className="page-title">订单管理</h1>
        <p className="page-subtitle">管理平台所有订单</p>
      </div>

      <Card>
        <div className="table-toolbar">
          <Space>
            <Input.Search placeholder="搜索订单" />
            <Select defaultValue="all" style={{ width: 120 }}>
              <Option value="all">全部状态</Option>
              <Option value="pending">待处理</Option>
              <Option value="processing">进行中</Option>
              <Option value="completed">已完成</Option>
              <Option value="cancelled">已取消</Option>
            </Select>
            <RangePicker />
          </Space>
        </div>
        <Table columns={columns} dataSource={orders} rowKey="id" />
      </Card>
    </div>
  );
};

export default OrderManagement;
